import React, { Component } from 'react';
import styles from './SplitLayout.module.css';
import Area from '../Area';

class SplitLayout extends Component {
  render() {
    let areaSizes = this.props.areaSizes;
    if (typeof areaSizes === 'string') {
      areaSizes = areaSizes.split(' ');
    }
    let mode = this.props.mode || 'preview'
    return (
      <div className={styles.main + ' ' + styles[this.props.direction] + ' ' + styles[mode]}>
        {areaSizes.map((areaSize, index) => {
          let areaConfig = this.props.areas[index] || {};
          areaSize = areaSize.trim();
          let flex = '0 0 auto';
          let fixedSize = 'auto';

          if (/^\d+$/.test(areaSize)) {
            if (areaSize === '0') {
              areaSize = '0 0 auto';
            }
            flex = areaSize;
          } else {
            fixedSize = areaSize;
          }
          let heightOrWidth = this.props.direction === 'row' ? 'width' : 'height';

          return (
            <div key={index} className={styles.areaContainer} style={{ flex, [heightOrWidth]: fixedSize }}>
              <Area {...this.props} index={index} config={areaConfig} onChange={this.props.onChange} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default SplitLayout;
